import { Component, ViewChild, Input, ElementRef } from "@angular/core";
import { SMMessageService } from "../../forms/Communication/Message/SMMessage.service";
import { TemplateService } from "../../forms/organizational-setup/setup/template/template.service";
import { AuthGuard } from "../../../core/helper/auth.guard";
import { SMStudentinfoService } from "../../forms/school-management/transaction/studentprofile/studentprofile.service";
import { NavModalComponent } from "../../../core/component/NavModal.Component";
import { AppConstants } from "../../../app.constant";
import { GenEnum } from "../../shared/general.enum";
import { LocalStorage } from "../../../core/helper/localStorage";
import { StudentbirthdayService } from "./studentbirthday.service";
import { IXSModalComponent } from "../../../components/ixsmodal/ixsmodal.component";
import { IXSDropdownComponent } from "../../../components/dropdown/dropdown.component";
import { StudentguardianService } from "../../forms/school-management/transaction/studentguardianlist/studentguardian/studentguardian.service";
import { BaseComponent } from "../../../core/component/Base.Component";
import { FormBuilder, FormGroup } from "@angular/forms";
import { IxsloaderComponent } from "../../../components/ixsloader/ixsloader.component";

@Component({
    moduleId: module.id,
    selector: "Student-birthday",
    templateUrl: "../Student-birthday/Studbirthday.component.html"
})

export class StudentBirthday extends BaseComponent {


    myForm: FormGroup;
    @ViewChild(IxsloaderComponent) loader: IxsloaderComponent;
    @ViewChild('Birthdaymodal') birthdaymodal: IXSModalComponent;
    @ViewChild('drop') drop: IXSDropdownComponent;
    @ViewChild('sms') sms: ElementRef;
    @ViewChild('MobApp') MobApp: ElementRef;


    protected localStorage: LocalStorage;
    studentid: number;
    studentimage: string;
    Section: String;
    imageSource: any;
    today: number = Date.now();
    time: Date;
    url: string;
    rolestxt: string;
    model: any = {};
    userclients: any;
    items = [];
    Firstname: string;
    Course: string;
    Age: number;
    dateofbirth: string;
    studimg: string;
    Guardianimg: string;
    dropvalue: any;
    grno: any;
    Msgtemplate: any;
    StudentGuardian: any[] = [];
    protected fb: FormBuilder = new FormBuilder();
    initilizeForm() {
        //this.title = "Studentbirthday";
        this.myForm = this.fb.group({
            'drop': ['', []],
            'sms': ['', []],
            'MobApp': ['', []],
            'firstname': ['', []],
        });
    }

    async modalInitialize() {


        // await this.getStudebtList(this.studentid);
    }

    constructor(private StudentbirthdayService: StudentbirthdayService,
        private auth: AuthGuard,
        private _SMStudentinfoService: SMStudentinfoService,
        private _SMStudentGuardianService: StudentguardianService,

        private smmessageservice: SMMessageService,
        private templateService: TemplateService,
    ) {
        super();
        this.initilizeForm();
        this.localStorage = AppConstants.injector.get(LocalStorage);
        this.imageSource =
            AppConstants.urls.api.base.replace("api/", "") + GenEnum.Image.imageUrl;

    }


    async getstudguardian(studentid) {
        this.StudentGuardian = this.LookupData.StudentGuardian = [];
        const dto = await this._SMStudentGuardianService.getStudentGuardianList(studentid);
        if (dto && dto.IsSuccess) {
            this.StudentGuardian = this.LookupData.StudentGuardian = dto.Data;

            this.StudentGuardian.forEach(element => {
                if (element.filename) {
                    element.Guardianimg = this.imageSource + element.filename;
                }
            });
        }
        else {
        }
    }




    async getstudbirthdaymodal(event) {

        this.loader.startLoading();
        this.studentid = Number(event.currentTarget.id);
        this.Firstname = event.currentTarget.children[1].innerText;
        this.Course = event.currentTarget.children[2].innerText;
        this.Section = event.currentTarget.children[3].innerText;
        this.Age = event.currentTarget.children[5].innerText;
        this.dateofbirth = event.currentTarget.children[6].innerText;
        this.grno = event.currentTarget.children[7].innerText;
        this.studentimage = event.currentTarget.children[0].children[0].src;
        await this.getstudguardian(this.studentid);
        await this.getsmstemplate();

        this.loader.stopLoading();
    }


    async getsmstemplate() {
        this.LookupData.smstemplate = [];
        const dto = await this.templateService.getAll();
        if (dto && dto.IsSuccess) {
            this.LookupData.smstemplate = dto.Data;
        }
    }

    filterData(event) {
        if (event.target.checked) {

            this.items.push({
                parentid: event.currentTarget.id,
                studentid: this.studentid
            })
            //this.showInfo(JSON.stringify(this.items));
        } else {
            let indexof = this.items.filter(o => o.parentid == event.currentTarget.id)[0]
            this.items.splice(indexof, 1);
            // this.showInfo(JSON.stringify(this.items));
        }
    }

    async Sentsms() {
        this.loader.startLoading();

        const result: any = {};
        const Data: any = {};

        let Msgtemplate = this.drop.data.filter(o => o.Id == this.drop.innerValue)[0];

        // let Msgtemplate = this.myForm.controls['drop'].value

        if (this.drop && this.drop.value && Msgtemplate) {
            let msgcaption = Msgtemplate.stxt;
            let msgtxt = Msgtemplate.ltxt;
            let tempalteId = this.drop.value;
            let smssent = this.sms && this.sms.nativeElement ? this.sms.nativeElement.checked : false;
            let mobappsent = this.MobApp && this.MobApp.nativeElement ? this.MobApp.nativeElement.checked : false;

            if (this.items === undefined || this.items.length === 0) {
                this.showErrors("Select Guardian");

                if (!smssent && !mobappsent) {
                    this.showErrors(" Select Sent Option ")
                }
                else {
                    let mobappsent = Data.mobileapp;
                    let smssent = Data.sms;
                }
            }
            else {
                if (Data) {

                    let entityid = Number(this.localStorage.get("selectedEntity"));
                    Data.entityid = entityid;
                    Data.lovstatusid = GenEnum.Activity_Status_Id.Active;
                    Data.msgtypeid = GenEnum.MessageType.Notification;
                    Data.lovsenttoid = GenEnum.SendBy.Individual;
                    Data.senttoid = GenEnum.SendTo.Parents;
                    Data.title = "";
                    Data.mobileapp = mobappsent;
                    Data.sms = smssent;
                    Data.msgdate = new Date();
                    Data.publishdate = new Date();
                    Data.publishtime = new Date(1970, 1, 1, new Date().getHours() + 5, new Date().getMinutes() + 2, 0);
                    Data.msgtxt = msgtxt;
                    Data.SMMessagelogs = this.items;
                    Data.title = msgcaption;
                    Data.templateid = tempalteId;
                    let json: any = {};
                    json.Data = Data;

                    const result = await this.smmessageservice.save(json);
                    if (result.IsSuccess) {
                        this.loader.stopLoading();

                        $('.modal').modal('hide');
                        this.showSuccess('Record saved successfully...');
                        this.loader.stopLoading();

                        this.drop.innerValue = undefined;
                        if (this.sms && this.sms.nativeElement)
                            this.sms.nativeElement.checked = false;

                        if (this.MobApp && this.MobApp.nativeElement)
                            this.MobApp.nativeElement.checked = false;
                        this.items = [];
                        // this.Studbirthday.modal.close();
                    }
                    else {
                        this.showErrors(result.Errors);
                        this.items = [];
                    }
                }
            }
        }
        else {
            this.showErrors("Select " + this.drop.caption);
        }
        this.loader.stopLoading();
    }
}






// WEBPACK FOOTER //
// ./src/app/shell/shell-components/Student-birthday/Studbirthday.component.ts